import React, { useState, useEffect, useRef } from 'react';
import { RxCross2 } from "react-icons/rx";
import CustomCalendar from './CustomCalendar';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { createAppointment, sendOtp, verifyOtp } from '../api/api';

const AppoinmentModal = ({ isOpen, onClose }) => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        message: ''
    });
    const navigate = useNavigate();
    const [phone, setPhone] = useState('');
    const [time, setTime] = useState('');
    const [error, setError] = useState('');
    const [errors, setErrors] = useState({});
    const [age, setAge] = useState('');
    const [inView, setInView] = useState(false);
    const [isVerified, setIsVerified] = useState(false);
    const [showTimePicker, setShowTimePicker] = useState(false);
    const [selectedTimes, setSelectedTimes] = useState(false);

    const [selectedDate, setSelectedDate] = useState(null);
    const [showCalendar, setShowCalendar] = useState(false);
    const [timeSlots, setTimeSlots] = useState([]);
    const currentDate = new Date();
    const [ageSuggestions, setAgeSuggestions] = useState([]);
    const [email, setEmail] = useState('');
    const [emailError, setEmailError] = useState('');
    const [otp, setOtp] = useState('');
    const [showOtpInput, setShowOtpInput] = useState(false);
    const [otpError, setOtpError] = useState('');
    const [popupVisible, setPopupVisible] = useState(false);
    const [notificationVisible, setNotificationVisible] = useState(false);

    // New states for OTP timer
    const [otpTimer, setOtpTimer] = useState(0);
    const [isOtpSent, setIsOtpSent] = useState(false);
    const [verifyButtonDisabled, setVerifyButtonDisabled] = useState(false);

    const formRef = useRef(null);
    const timePickerRef = useRef(null);
    const calendarRef = useRef(null);
    const ageRef = useRef(null);
    const headingRef = useRef(null);

    // OTP Timer useEffect
    useEffect(() => {
        let interval;
        if (otpTimer > 0) {
            interval = setInterval(() => {
                setOtpTimer(prev => prev - 1);
            }, 1000);
        } else if (otpTimer === 0 && isOtpSent) {
            setVerifyButtonDisabled(false);
        }
        return () => clearInterval(interval);
    }, [otpTimer, isOtpSent]);

    const generateTimeSlots = (selectedDate) => {
        const slots = [];
        const currentTime = new Date();
        const currentHour = currentTime.getHours();
        const currentMinute = currentTime.getMinutes();
        const maxHour = 19;

        const isToday = selectedDate.toDateString() === currentDate.toDateString();

        for (let hour = 10; hour <= maxHour; hour++) {
            const suffix = hour < 12 ? 'AM' : 'PM';
            const formattedHour = hour > 12 ? hour - 12 : hour;

            const slot1 = `${formattedHour}:00 ${suffix}`;
            const slot2 = `${formattedHour}:30 ${suffix}`;

            const slot1Hour = hour;
            const slot1Minute = 0;

            const slot2Hour = hour;
            const slot2Minute = 30;

            const currentTimeInMinutes = currentHour * 60 + currentMinute;
            const slot1TimeInMinutes = slot1Hour * 60 + slot1Minute;
            const slot2TimeInMinutes = slot2Hour * 60 + slot2Minute;

            if (isToday) {
                const isSlot1Past = slot1TimeInMinutes <= currentTimeInMinutes;
                const isSlot2Past = slot2TimeInMinutes <= currentTimeInMinutes;

                if (!isSlot1Past) slots.push({ time: slot1, isDisabled: false });
                else slots.push({ time: slot1, isDisabled: true });

                if (hour < maxHour && !isSlot2Past) slots.push({ time: slot2, isDisabled: false });
                else if (hour < maxHour) slots.push({ time: slot2, isDisabled: true });
            } else {
                slots.push({ time: slot1, isDisabled: false });
                if (hour < maxHour) slots.push({ time: slot2, isDisabled: false });
            }
        }
        return slots;
    };

    useEffect(() => {
        if (selectedDate) {
            setTime('');
            setSelectedTimes(false);
            setTimeSlots(generateTimeSlots(selectedDate));
        }
    }, [selectedDate]);

    const validatePhoneNumber = (phoneNumber) => {
        const regex = /^[0-9]{10}$/;
        return regex.test(phoneNumber);
    };

    const handleTimeChange = (e) => {
        setTime(e.target.value);
        setError('');
    };

    const handleTimeSelect = (selectedTime) => {
        setTime(selectedTime);
        setShowTimePicker(false);
        setSelectedTimes(true);
    };

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (timePickerRef.current && !timePickerRef.current.contains(e.target)) {
                setShowTimePicker(false);
            }
            if (calendarRef.current && !calendarRef.current.contains(e.target)) {
                setShowCalendar(false);
            }
            if (ageRef.current && !ageRef.current.contains(e.target)) {
                setAgeSuggestions([]);
            }
        };
        document.addEventListener('click', handleClickOutside);

        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleAgeChange = (e) => {
        const value = e.target.value;

        if (value === '') {
            setFormData((prev) => ({
                ...prev,
                age: value,
            }));
            setAgeSuggestions([]);
            return;
        }

        if (/^[0-9]{0,2}$/.test(value)) {
            setFormData((prev) => ({
                ...prev,
                age: value,
            }));

            if (value.length >= 1) {
                const filteredAges = Array.from({ length: 72 }, (_, i) => i + 4)
                    .filter(age => age.toString().startsWith(value));

                setAgeSuggestions(filteredAges);
            } else {
                setAgeSuggestions([]);
            }
        }
    };

    const handleAgeSelect = (selectedAge) => {
        setFormData((prev) => ({
            ...prev,
            age: selectedAge,
        }));
        setAgeSuggestions([]);
    };

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                const entry = entries[0];
                if (entry.isIntersecting) {
                    setInView(true);
                }
            },
            { threshold: 0.5 }
        );

        if (headingRef.current) {
            observer.observe(headingRef.current);
        }

        return () => {
            if (headingRef.current) {
                observer.unobserve(headingRef.current);
            }
        };
    }, []);

    const handlePhoneChange = (e) => {
        const value = e.target.value.replace(/[^0-9]/g, '').slice(0, 10);
        setPhone(value);
    };

    const handleEmailChange = (e) => {
        const value = e.target.value;
        setEmail(value);

        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

        if (value && !emailRegex.test(value)) {
            setEmailError('Please enter a valid email address');
        } else {
            setEmailError('');
        }
    };

    const handleVerify = async () => {
        if (!validatePhoneNumber(phone)) {
            setError('Invalid phone number. Please enter a valid 10-digit number.');
            return;
        }

        try {
            // Immediately disable the verify button
            setVerifyButtonDisabled(true);
            setError('');

            const response = await sendOtp(phone);

            if (response.status) {
                setIsOtpSent(true);
                setShowOtpInput(true);
                setOtpTimer(30); // 30 seconds timer
                setError('');
                console.log("OTP sent successfully from api:", response.data.otp);
                toast.success('OTP sent successfully!');
            } else {
                // setError('Failed to send OTP');
                setError(response.message)
                setVerifyButtonDisabled(false); // Re-enable if failed
                toast.error(response.message);
            }
        } catch (err) {
            setError(err.response.data.message || 'An error occurred while sending OTP');
            setVerifyButtonDisabled(false); // Re-enable if error
            toast.error(err.response.data.message || 'An error occurred while sending OTP');
        }
    };

    const handleOtpChange = (e) => {
        setOtp(e.target.value);
        setOtpError('');
    };

    const handleOtpSubmit = async () => {
        if (otp.trim() === "") {
            setOtpError("Please enter the OTP.");
            return;
        }

        if (otp.length !== 4) {
            setOtpError("OTP must be 4 digits.");
            return;
        }

        try {
            const response = await verifyOtp(phone, otp);

            if (response.status && response.data) {
                setIsVerified(true);
                setOtpError("");
                setShowOtpInput(false);
                setIsOtpSent(false);
                setOtpTimer(0);
                setVerifyButtonDisabled(false);
                console.log("OTP verified successfully!");
                toast.success('Phone number verified successfully!');
            } else {
                // Show wrong OTP message
                setOtpError("Wrong OTP. Please try again.");
                toast.error('Wrong OTP. Please try again.');
            }
        } catch (err) {
            // Handle API errors and show appropriate message
            if (err.response && err.response.data) {
                setOtpError(err.response.data.message || "Wrong OTP. Please try again.");
                toast.error(err.response.data.message || 'Wrong OTP. Please try again.');
            } else {
                setOtpError("Wrong OTP. Please try again.");
                toast.error('Wrong OTP. Please try again.');
            }
        }
    };

    const validate = () => {
        const errors = {};

        if (!formData.name.trim()) {
            errors.name = 'Name is required!';
        } else if (formData.name.length < 3) {
            errors.name = 'Name must be at least 3 characters long!';
        }

        if (!formData.mode_consultation) {
            errors.mode_consultation = 'Mode of Consultation is required!';
        }

        if (!formData.purpose) {
            errors.purpose = 'Purpose is required!';
        }

        if (!formData.gender) {
            errors.gender = 'Gender is required!';
        }
        if (!selectedDate) {
            errors.date = 'Date is required!';
        }
        if (!selectedTimes) {
            errors.time = 'Slot Time is required!';
        }

        if (!formData.age || !/^[0-9]{1,2}$/.test(formData.age)) {
            errors.age = 'Age is required';
        } else if (formData.age < 4 || formData.age > 75) {
            errors.age = 'Age must be between 14 and 55!';
        }

        setErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validate()) return;

        if (!isVerified) {
            setError('Please verify your phone number before submitting.');
            return;
        }
        if (!formData.age || isNaN(formData.age) || formData.age < 4 || formData.age > 75) {
            setError('Age must be between 4 and 75 years.');
            return;
        }

        const appointmentData = {
            name: formData.name,
            email: email,
            phone: phone,
            mode_consultation: formData.mode_consultation,
            purpose: formData.purpose,
            age: formData.age,
            gender: formData.gender,
            appointment_date: selectedDate.toISOString().split('T')[0],
            appointment_time: time,
            comments: formData.message
        };

        console.log("Appointment Data being sent:", appointmentData);

        try {
            const response = await createAppointment(appointmentData);

            if (response.data) {
                setNotificationVisible(true);

                setTimeout(() => {
                    setNotificationVisible(false);
                    window.location.href = response.data.appoinemtLink;
                }, 100);

                resetForm();
            } else {
                toast.error('Failed to book appointment!');
            }
        } catch (error) {
            console.error('Error creating appointment:', error);
            if (error.response && error.response.data) {
                console.error('API Error Response:', error.response.data);
            }
            toast.error('Failed to book appointment!');
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({ ...prevData, [name]: value }));
    };

    const resetForm = () => {
        setPhone('');
        setTime('');
        setError('');
        setAge('');
        setIsVerified(false);
        setShowTimePicker(false);
        setSelectedDate(null);
        setAgeSuggestions([]);
        setEmail('');
        setEmailError('');
        setOtp('');
        setShowOtpInput(false);
        setOtpError('');
        setOtpTimer(0);
        setIsOtpSent(false);
        setVerifyButtonDisabled(false);

        setFormData({
            ...formData,
            name: '',
            purpose: '',
            mode_consultation: '',
            gender: ''
        });
    };

    useEffect(() => {
        if (isOpen) {
            resetForm();
        }
    }, [isOpen]);

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white p-5 rounded-md w-full max-w-[550px] overflow-auto max-h-screen relative">
                <h2
                    ref={headingRef}
                    className="custom-text-space text-lg md:pt-0 pt-4 sm:text-xl font-bold font-lato text-gray-800 text-center md:text-left font-merriweather">
                    Book An Appointment Online!
                </h2>
                {popupVisible && (
                    <div className="popup">
                        Form submitted successfully!
                    </div>
                )}
                <p className="custom-text-space text-gray-500 text-center md:text-left font-lato">
                    Schedule an online appointment with us today and experience the convenience of connecting from the comfort of your home. Let us help you with personalised support tailored to your needs.
                </p>

                <form className="space-y-4 " onSubmit={handleSubmit}>
                    <div className="flex flex-col sm:flex-row sm:space-x-4">
                        <div className="w-full sm:w-1/2">
                            <label htmlFor="name" className="text-gray-700 text-sm font-lato">
                                Name <span className="text-danger">*</span>
                            </label>
                            <input
                                id="name"
                                type="text"
                                placeholder="Enter your name"
                                className="w-full p-2 border border-gray-300 rounded focus:border-[#1E88E5] focus:outline-none text-sm font-lato"
                                name='name'
                                value={formData.name}
                                onChange={handleChange}
                            />
                            {errors.name && <p className='errors errors_name'>{errors.name}</p>}
                        </div>

                        <div className="w-full sm:w-1/2">
                            <label htmlFor="consultationMode" className="text-gray-700 text-sm font-lato">
                                Mode of Consultation <span className="text-danger">*</span>
                            </label>
                            <select
                                id="consultationMode"
                                className="w-full p-2 border border-gray-300 rounded focus:border-[#1E88E5] focus:outline-none text-sm font-lato"
                                name='mode_consultation'
                                value={formData.mode_consultation}
                                onChange={handleChange}
                            >
                                <option value="" disabled selected>Mode of Consultation</option>
                                <option value="video">Video Call</option>
                                <option value="audio">Voice Call</option>
                                <option value="one-to-one" disabled>One to One</option>
                            </select>
                            {errors.mode_consultation && <p className='errors errors_mode_consultation'>{errors.mode_consultation}</p>}
                        </div>
                    </div>

                    <div className="flex flex-col sm:flex-row sm:space-x-4">
                        <div className="w-full sm:w-1/2">
                            <label htmlFor="purpose" className="text-gray-700 mb-1 text-sm font-lato">
                                Purpose <span className="text-danger">*</span>
                            </label>
                            <input
                                id="purpose"
                                type="text"
                                placeholder="Enter the purpose"
                                className="w-full p-2 border border-gray-300 rounded focus:border-[#1E88E5] focus:outline-none text-sm font-lato"
                                name='purpose'
                                value={formData.purpose}
                                onChange={handleChange}
                            />
                            {errors.purpose && <p className='errors errors_purpose'>{errors.purpose}</p>}
                        </div>

                        <div className="w-full sm:w-1/2 sm:flex-row flex flex-col sm:flex-row sm:space-x-4">
                            <div className="w-full sm:w-full relative">
                                <label htmlFor="age" className="text-gray-700 mb-1 text-sm font-lato">
                                    Age <span className="text-danger">*</span>
                                </label>
                                <input
                                    name="age"
                                    value={formData.age}
                                    onChange={handleAgeChange}
                                    id="age"
                                    ref={ageRef}
                                    type="number"
                                    placeholder="Enter your age"
                                    className="w-full p-2 border border-gray-300 rounded focus:border-[#1E88E5] focus:outline-none text-sm font-lato"
                                />
                                {errors.age && <p className="errors errors_age">{errors.age}</p>}

                                {ageSuggestions.length > 0 && (
                                    <ul
                                        className="absolute bg-white border border-gray-300 rounded shadow-lg z-50 max-h-48 overflow-y-auto"
                                        style={{ top: '100%', left: 0, right: 0 }}
                                    >
                                        {ageSuggestions.map((suggestedAge) => (
                                            <li
                                                key={suggestedAge}
                                                onClick={() => handleAgeSelect(suggestedAge)}
                                                className="p-1 hover:bg-gray-100 cursor-pointer"
                                            >
                                                {suggestedAge}
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                            <div className="w-full sm:w-full">
                                <label htmlFor="gender" className="text-gray-700 mb-1 text-sm font-lato">
                                    Gender <span className="text-danger">*</span>
                                </label>
                                <select
                                    id="gender"
                                    className="w-full p-2 border border-gray-300 rounded focus:border-[#1E88E5] focus:outline-none text-sm font-lato"
                                    name='gender'
                                    value={formData.gender}
                                    onChange={handleChange}
                                >
                                    <option value="" disabled selected>Select Gender</option>
                                    <option value="male">Male</option>
                                    <option value="female">Female</option>
                                    <option value="other">Other</option>
                                </select>
                                {errors.gender && <p className='errors errors_gender'>{errors.gender}</p>}
                            </div>
                        </div>
                    </div>

                    <div className="flex flex-col sm:flex-row sm:space-x-4">
                        <div className="w-full sm:w-1/2">
                            <label htmlFor="date" className="text-gray-700 mb-1 text-sm font-lato">
                                Date of Appointment <span className="text-danger">*</span>
                            </label>
                            <CustomCalendar selectedDate={selectedDate} setSelectedDate={setSelectedDate} minDate={currentDate} name='date'
                                value={formData.date}
                                onChange={handleChange} />
                            {errors.date && <p className='errors errors_date'>{errors.date}</p>}
                        </div>

                        <div className="w-full sm:w-1/2">
                            <label htmlFor="time" className="text-gray-700 mb-1 text-sm font-lato">
                                Time of Appointment <span className="text-danger">*</span>
                            </label>
                            <div className="relative" ref={timePickerRef}>
                                <button
                                    type="button"
                                    className="w-full p-2 mb-2 border border-gray-300 rounded focus:border-[#1E88E5] text-left focus:outline-none text-sm font-lato"
                                    onClick={() => setShowTimePicker(prev => !prev)}
                                >
                                    {time || "Select Time"}
                                </button>
                                {showTimePicker && (
                                    <div className="absolute z-20 bg-white border border-gray-300 shadow-lg rounded max-w-xs overflow-y-auto">
                                        <div className="grid grid-cols-4 gap-4 p-2 h-52 sm:gap-0">
                                            {timeSlots.map((slot) => (
                                                <button
                                                    key={slot.time}
                                                    onClick={() => !slot.isDisabled && handleTimeSelect(slot.time)}
                                                    className={`px-5 py-2 text-xs rounded 
                                                    ${slot.isDisabled ? 'cursor-not-allowed text-gray-500' : 'hover:bg-blue-100 text-black'}`}
                                                    disabled={slot.isDisabled}
                                                >
                                                    <span>
                                                        {slot.time}
                                                    </span>
                                                </button>
                                            ))}
                                        </div>
                                    </div>
                                )}
                                {errors.time && <p className='errors errors_time'>{errors.time}</p>}
                            </div>
                        </div>
                    </div>

                    <div className="flex flex-col sm:flex-row sm:space-x-4">
                        <div className="w-full sm:w-1/2">
                            <label htmlFor="email" className="text-gray-700 mb-1 text-sm font-lato">Email Address</label>
                            <input
                                id="email"
                                type="email"
                                placeholder="Enter your email"
                                className="w-full p-2 border border-gray-300 mb-4 sm:mb-0 rounded focus:border-[#1E88E5] focus:outline-none text-sm font-lato"
                                value={email}
                                name="email"
                                onChange={handleEmailChange}
                            />
                            {emailError && <p className="text-red-500 text-xs mt-2">{emailError}</p>}
                            {errors.email && <p className='errors errors_email'>{errors.email}</p>}
                        </div>
                        <div className="w-full sm:w-1/2">
                            <label htmlFor="phone" className="text-gray-700 mb-1 text-sm font-lato">
                                Phone Number <span className="text-danger">*</span>
                            </label>
                            <div className="relative">
                                <input
                                    id="phone"
                                    type="tel"
                                    placeholder="Enter your phone number"
                                    className="w-full p-2 border border-gray-300 rounded focus:border-[#1E88E5] focus:outline-none text-sm font-lato"
                                    name='phone'
                                    value={phone}
                                    onChange={handlePhoneChange}
                                />
                                {errors.phone && <p className='errors errors_phone'>{errors.phone}</p>}

                                <button
                                    type="button"
                                    onClick={handleVerify}
                                    disabled={verifyButtonDisabled || !phone || phone.length !== 10}
                                    className={`absolute right-3 top-2 text-sm font-lato ${verifyButtonDisabled || !phone || phone.length !== 10
                                        ? 'text-gray-400 cursor-not-allowed'
                                        : 'text-[#1E88E5] hover:text-[#1565C0]'
                                        }`}
                                >
                                    {verifyButtonDisabled && otpTimer > 0 ? `Resend in ${otpTimer}s` : 'Verify'}
                                </button>
                            </div>
                            {error && <p className="text-red-500 text-xs mt-2">{error}</p>}
                            {isVerified && <p className="text-green-500 text-xs mt-2">Phone number verified successfully!</p>}
                        </div>
                    </div>

                    {showOtpInput && !isVerified && (
                        <div className="flex flex-col sm:flex-row sm:space-x-4">
                            <div className="w-full sm:w-2/3">
                                <label htmlFor="otp" className="text-gray-700 mb-1 text-sm font-lato">
                                    Enter OTP <span className="text-danger">*</span>
                                </label>
                                <input
                                    id="otp"
                                    type="text"
                                    value={otp}
                                    onChange={handleOtpChange}
                                    placeholder="Enter 4-digit OTP"
                                    className={`w-full p-2 border rounded focus:outline-none text-sm font-lato ${otpError ? 'border-red-500 focus:border-red-500' : 'border-gray-300 focus:border-[#1E88E5]'
                                        }`}
                                    required
                                    maxLength="4"
                                />
                                {otpError && (
                                    <p className="text-red-500 text-xs mt-2 flex items-center">
                                        <span className="mr-1">❌</span>
                                        {otpError}
                                    </p>
                                )}
                            </div>

                            <div className="w-full sm:w-1/3">
                                <button
                                    type="button"
                                    onClick={handleOtpSubmit}
                                    className="w-full bg-[#bf9b30] text-white text-sm py-2 rounded mt-6 font-roboto transform transition-all duration-300 ease-in-out hover:bg-[#986b1f]"
                                >
                                    Verify OTP
                                </button>
                            </div>
                        </div>
                    )}

                    <div>
                        <label htmlFor="comments" className="text-gray-700 mb-1 text-sm font-lato">Comments</label>
                        <textarea
                            id="comments"
                            placeholder="Enter your comments"
                            className="w-full p-2 border border-gray-300 rounded focus:border-[#1E88E5] focus:outline-none font-lato"
                        />
                    </div>

                    <button
                        type="submit"
                        className="w-full bg-[#bf9b30] text-white py-2 rounded mt-4 font-roboto transform transition-all duration-300 ease-in-out hover:bg-[#986b1f]"
                        disabled={!isVerified}
                    >
                        {isVerified ? 'Submit' : 'Please Verify Phone Number'}
                    </button>
                </form>
                <button
                    onClick={onClose}
                    className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
                >
                    <RxCross2 size={24} />
                </button>
            </div>
            <ToastContainer />
        </div>
    );
};

export default AppoinmentModal;